module.exports = __webpack_public_path__ + "img/wales.ed92423f.svg";